import { apiConfig, config } from "app-config";
import authService from "./authService";
import cacheService from "./cacheService";
import errorHandlingService from "./errorHandlingService";

async function getJsonValue<T>(res: Response): Promise<T> {
  return (await res.json())?.value as T;
}

async function getJsonData<T>(res: Response): Promise<T> {
  return (await res.json())?.data as T;
}

interface FetchWithCacheFallbackOptions {
  checkResValidity: boolean;
}

async function fetchWithCacheFallback(
  url: string,
  fetchOptions: RequestInit,
  cacheName: string,
  options: FetchWithCacheFallbackOptions = { checkResValidity: true }
): Promise<Response> {
  try {
    const resp = await fetch(url, fetchOptions);
    return options.checkResValidity
      ? errorHandlingService.defaultAndDefined(resp)
      : errorHandlingService.defaultErrorHandling(resp);
  } catch (error) {
    return await cacheService.match(url, cacheName);
  }
}

/**
 * Génère les headers HTTP nécessaires pour requêter nos APIs via l'APIM
 * en fonction des scopes demandés
 * @returns Les Headers
 */
async function createHeaders(scopes: Array<string>): Promise<HeadersInit> {
  const accessToken = await authService.getAccessToken(scopes);

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
    "Ocp-Apim-Subscription-Key": apiConfig.apimSubscriptionKey,
    "Sdeapps-Version": config.appVersion,
    "Sdeapps-Application": config.appName,
  };
}

/**
 * Lit une réponse d'API et retourne les données du body de réponse après avoir vérifier le statut de celle-ci
 * @param response Réponse de l'API
 * @returns Retourne les données typées en l'absence d'erreur ou code erreur
 */
async function handleResponse<T>(response: Response): Promise<T> {
  errorHandlingService.defaultAndDefined(response);
  return await networkService.getJsonData<T>(response);
}

const networkService = {
  getJsonValue,
  getJsonData,
  fetchWithCacheFallback,
  createHeaders,
  handleResponse,
};
export default networkService;
